import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { Button as c } from "../shared/button/Button.component.js";
import { ButtonAlignmentEnum as h, ButtonSizeEnum as n, ButtonThemeEnum as x } from "../shared/button/types.js";
import { useCallback as f } from "react";
import { CopyLinkIcon as k } from "./icons/CopyLInk.icon.js";
import { DeleteIcon as v } from "./icons/Delete.icon.js";
import { DownloadIcon as E } from "./icons/Download.icon.js";
import { RenameIcon as z } from "./icons/Rename.icon.js";
import { ViewFileIcon as w } from "./icons/ViewFile.icon.js";
const q = ({
  copies: p,
  onClose: a,
  onDelete: r,
  onCopy: m,
  onDownload: d,
  onRename: e,
  onView: l
}) => {
  const u = f(() => {
    m == null || m(), a == null || a();
  }, [a, m]), s = f(() => {
    d == null || d(), a == null || a();
  }, [d, a]), g = f(() => {
    r == null || r(), a == null || a();
  }, [r, a]), b = f(() => {
    e == null || e(), a == null || a();
  }, [e, a]), N = f(() => {
    l == null || l(), a == null || a();
  }, [a, l]);
  return /* @__PURE__ */ i("div", { className: "app:p-0 app:gap-2 app:flex app:flex-col", children: [
    l && /* @__PURE__ */ t(
      c,
      {
        theme: x.naked,
        size: n.xs,
        align: h.left,
        className: "app:[--button--padding:0px] app:[--button--min-width--xs:20px]",
        type: "button",
        onClick: N,
        children: /* @__PURE__ */ i("div", { className: "app:flex app:gap-2 app:items-center", children: [
          /* @__PURE__ */ t(w, { className: "app:w-5 app:h-5" }),
          /* @__PURE__ */ t("span", { children: p == null ? void 0 : p.fileExplorer.actions.view })
        ] })
      }
    ),
    d && /* @__PURE__ */ t(
      c,
      {
        theme: x.naked,
        size: n.xs,
        align: h.left,
        className: "app:[--button--padding:0px] app:[--button--min-width--xs:20px] app:text-stone-400 app:hover:text-stone-950",
        type: "button",
        onClick: s,
        children: /* @__PURE__ */ i("div", { className: "app:flex app:gap-2 app:items-center", children: [
          /* @__PURE__ */ t(E, { className: "app:w-5 app:h-5" }),
          /* @__PURE__ */ t("span", { children: p == null ? void 0 : p.fileExplorer.actions.download })
        ] })
      }
    ),
    m && /* @__PURE__ */ t(
      c,
      {
        theme: x.naked,
        size: n.xs,
        align: h.left,
        className: "app:[--button--padding:0px] app:[--button--min-width--xs:20px]",
        type: "button",
        onClick: u,
        children: /* @__PURE__ */ i("div", { className: "app:flex app:gap-2 app:items-center", children: [
          /* @__PURE__ */ t(k, { className: "app:w-5 app:h-5 " }),
          /* @__PURE__ */ t("span", { children: p == null ? void 0 : p.fileExplorer.actions.copyLink })
        ] })
      }
    ),
    e && /* @__PURE__ */ t(
      c,
      {
        theme: x.naked,
        size: n.xs,
        align: h.left,
        className: "app:[--button--padding:0px] app:[--button--min-width--xs:20px]",
        type: "button",
        onClick: b,
        children: /* @__PURE__ */ i("div", { className: "app:flex app:gap-2 app:items-center", children: [
          /* @__PURE__ */ t(z, { className: "app:w-5 app:h-5" }),
          /* @__PURE__ */ t("span", { children: p == null ? void 0 : p.fileExplorer.actions.rename })
        ] })
      }
    ),
    r && /* @__PURE__ */ t(
      c,
      {
        theme: x.naked,
        size: n.xs,
        align: h.left,
        className: "app:[--button--padding:0px] app:[--button--min-width--xs:20px]",
        type: "button",
        onClick: g,
        children: /* @__PURE__ */ i("div", { className: "app:flex app:gap-2 app:items-center", children: [
          /* @__PURE__ */ t(v, { className: "app:w-5 app:h-5" }),
          /* @__PURE__ */ t("span", { children: p == null ? void 0 : p.fileExplorer.actions.delete })
        ] })
      }
    )
  ] });
};
export {
  q as FileActionsDropdown
};
